// --no-test-for-file

import {DeviceAddResponse} from "../types/Device"
import audioFile from "assets/notification_sound.mp3"

export const sendNotification = (data: DeviceAddResponse["data"][0]) => {
  new Notification("Новый запрос на подключение", {
    tag: data.id.toString()
  })
  new Audio(audioFile).play()
}
